module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ArcProgressbar/images/icon-locked.57cf2670.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ArcProgressbar/images/icon-locked.png
// module id = 2925
// module chunks = 11